import React from 'react';
import './HowItWorks.css';
import { FaUserPlus, FaIdBadge, FaCogs, FaUserFriends, FaEnvelope, FaGraduationCap } from 'react-icons/fa';
const howItWorksData = [
  {
    icon: <FaUserPlus />,
    title: 'Sign Up',
    desc: 'Create your profile to explore the skillverse. Subscribe to offer services.'
  },
  {
    icon: <FaIdBadge />,
    title: 'Build your personal brand and trust',
    desc: 'Start sharing your knowledge in your preferd categories and get connected to followers.'
  },
  {
    icon: <FaCogs />,
    title: 'Setup your MySpace',
    desc: 'List your services and the related data.'
  },
  {
    icon: <FaUserFriends />,
    title: 'Connect',
    desc: 'Get connected with someone who wants your expertise.'
  },
  {
    icon: <FaEnvelope />,
    title: 'Send a query',
    desc: 'Send query to profile of your choice.'
  },
  {
    icon: <FaGraduationCap />,
    title: 'Upskill',
    desc: 'Upskill yourself with knowledge.'
  },
];

const HowItWorks = () => {
  return (
    <section className="how-it-works">
      <h2>How It Works</h2>
      <div className="hiw-grid">
        {howItWorksData.map((item, index) => (
          <div key={index} className="hiw-item">
            <div className="hiw-icon">{item.icon}</div>
            <h3 className="hiw-title">{item.title}</h3>
            <p className="hiw-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
